import { WIX_STATUS_PAGE_LINK } from '../../consts';
import { Text, TextButton } from '@wix/design-system';
import { Trans } from '@wix/wix-i18n-config';
import React from 'react';
export const getFootNoteProps = _ref => {
  let {
    showStatusFootnote
  } = _ref;
  return showStatusFootnote ? {
    footnoteSkin: 'light',
    footnote: /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "errors.status-page-foot-note"
    }, /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      onClick: () => {
        window.open(WIX_STATUS_PAGE_LINK);
      }
    })))
  } : {};
};
//# sourceMappingURL=getFootNoteProps.js.map